module.exports = __webpack_public_path__ + "img/icon-draggable.00dd1bd2.svg";